var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import capitalize from "@material-ui/core/utils/capitalize";
import { Box } from "../box";
import { makeStyles } from "../styles";
import { Text } from "../text";
import clsx from "../utils/clsx";
import { AuFlagSvg, EuFlagSvg, JpFlagSvg, PiFlagSvg, UsFlagSvg } from "./flags";
export var QuantumRegionComponentName = "QuantumRegion";
function localityIcon(locality) {
    switch (locality) {
        case "au":
            return AuFlagSvg;
        case "eu":
            return EuFlagSvg;
        case "jp":
            return JpFlagSvg;
        case "pi":
            return PiFlagSvg;
        case "us":
            return UsFlagSvg;
        default:
            return UsFlagSvg;
    }
}
function getLabelForLocality(locality) {
    if (!locality) {
        return "US"; // default if none provided
    }
    if (locality === "pi") {
        return "Private Instance";
    }
    return locality.toUpperCase();
}
export var useRegionStyles = makeStyles(function (theme) {
    var defaultSize = {
        // width: theme.typography.pxToRem(19.2),
        height: theme.typography.pxToRem(20),
    };
    var smallSize = {
        height: theme.typography.pxToRem(16),
    };
    return {
        root: {},
        flag: __assign(__assign({}, defaultSize), { verticalAlign: "middle", display: "inline-block" }),
        label: {
            color: theme.palette.text.secondary,
        },
        labelSmall: {
            marginLeft: theme.spacing(0.5),
        },
        labelMedium: {
            marginLeft: theme.spacing(1),
        },
        sizeSmall: __assign({}, smallSize),
    };
}, { name: QuantumRegionComponentName });
export var Region = React.forwardRef(function (props, ref) {
    var classes = useRegionStyles(props);
    var locality = props.locality, _a = props.size, size = _a === void 0 ? "medium" : _a, icon = props.icon, labelProp = props.label, _b = props.labelTypographyProps, labelTypographyProps = _b === void 0 ? {} : _b, className = props.className, 
    // don't forward on to the root
    propClasses = props.classes, rootProps = __rest(props, ["locality", "size", "icon", "label", "labelTypographyProps", "className", "classes"]);
    var flag = icon;
    if (!icon) {
        var LocalityIcon = localityIcon(locality);
        flag = (React.createElement(LocalityIcon, { "aria-hidden": true, className: clsx(classes.flag, size && classes["size" + capitalize(size)]) }));
    }
    var label = labelProp != null ? labelProp : getLabelForLocality(locality);
    return (React.createElement(Box, __assign({ className: clsx(classes.root, className), component: "span", display: "inline-flex", alignItems: "center" }, { ref: ref }, rootProps),
        flag,
        !!label && (React.createElement(Text, __assign({ variant: size === "small" ? "caption" : "body2", color: size === "small" ? "textSecondary" : "textPrimary", className: clsx(classes.label, size && classes["label" + capitalize(size)]) }, labelTypographyProps), label))));
});
